import { render, staticRenderFns } from "./CenteredMessage.vue?vue&type=template&id=85b8ebf0&"
import script from "./CenteredMessage.vue?vue&type=script&lang=js&"
export * from "./CenteredMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports